import React from 'react';
import './Sobre.css';
import CafeImage from '../../assets/cafe.jpg'; // Ajuste o caminho da imagem
import App1Image from '../../assets/app1.jpg'; // Ajuste os caminhos das imagens dos apps
import App2Image from '../../assets/app2.jpg';
import App3Image from '../../assets/app3.jpg';
import App4Image from '../../assets/app4.jpg';

const SobreNos = () => {
  return (
    <div className="sobre-nos-container">
      <div className="sobre-nos-header">
        <div className="sobre-nos-image">
          <img src={CafeImage} alt="Café" />
        </div>
        <div className="sobre-nos-text">
          <h1>Sobre Nós</h1>
          <p>
            CustosAgro Ltda. é uma empresa inovadora, dedicada ao desenvolvimento de aplicativos para dispositivos móveis, com foco exclusivo no agronegócio. Especializamo-nos em criar soluções digitais que auxiliem produtores rurais, gestores e empresas do setor a calcular e monitorar custos de produção, rentabilidade e viabilidade econômica de seus negócios. Nossa proposta é simplificar o controle financeiro e aumentar a eficiência e transparência na gestão de propriedades agrícolas, permitindo aos usuários tomar decisões fundamentadas e estratégicas.
          </p>
        </div>
      </div>

      <div className="section-box visao">
        <h2>Visão</h2>
        <p>
          Aspiramos ser a principal referência no mercado de aplicativos para controle financeiro do agronegócio. Queremos liderar uma transformação digital no setor, sendo reconhecidos como a empresa que melhor entende as necessidades do produtor e entrega soluções que realmente fazem a diferença no campo. Nosso objetivo é contribuir para o desenvolvimento econômico do Brasil, apoiando a modernização e a sustentabilidade do setor agropecuário por meio de ferramentas que promovem a eficiência e o sucesso de nossos clientes.
        </p>
      </div>

      <div className="section-box missao">
        <h2>Missão</h2>
        <p>
          Nossa missão é empoderar o agronegócio brasileiro com ferramentas que tornem o controle financeiro e a análise de rentabilidade mais acessíveis, precisos e integrados ao dia a dia do produtor. Através de tecnologia intuitiva e confiável, oferecemos uma visão clara dos custos e da rentabilidade de cada etapa do processo produtivo, auxiliando nossos clientes a identificar oportunidades de melhoria e maximizar seus resultados. Nosso compromisso é, assim, elevar a gestão financeira das propriedades rurais, tornando o setor mais competitivo e sustentável.
        </p>
      </div>

      <div className="section-box valores">
        <h2>Valores</h2>
        <p>
          Nossos valores são sustentados pela confiabilidade e inovação. Acreditamos na criação de aplicativos robustos e precisos, que possibilitem uma visão detalhada e acessível da gestão de custos, rentabilidade e viabilidade econômica dos nossos clientes. Valorizamos uma equipe altamente qualificada, com experiência em modelagem econômica e desenvolvimento de soluções móveis, que trabalha incansavelmente para adaptar nossos produtos às dinâmicas e necessidades do agronegócio. Além disso, prezamos pela ética e compromisso com a qualidade, garantindo que todas as soluções entregues sejam seguras, intuitivas e efetivas para o desenvolvimento sustentável do setor.
        </p>
      </div>

      <div className="apps-section">
        <h2>Confira nossos aplicativos</h2>
        <div className="apps-grid">
          <div className="app-card">
            <img src={App1Image} alt="App 1" />
            <div className="app-overlay">
              <h3>CalcLeite</h3>
            </div>
          </div>
          <div className="app-card">
            <img src={App2Image} alt="App 2" />
            <div className="app-overlay">
              <h3>CalcAgro</h3>
            </div>
          </div>
          <div className="app-card">
            <img src={App3Image} alt="App 3" />
            <div className="app-overlay">
              <h3>CalcCafé</h3>
            </div>
          </div>
          <div className="app-card">
            <img src={App4Image} alt="App 4" />
            <div className="app-overlay">
              <h3>CalcBov</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SobreNos;